//extracted by mini-css-extract-plugin
export default {"title":"SaveForLaterPopUp_title__JNPLl","title__close_button":"SaveForLaterPopUp_title__close_button__civfg"};;